import { render, staticRenderFns } from "./membershipLotsDetails.vue?vue&type=template&id=55d98994"
import script from "./membershipLotsDetails.vue?vue&type=script&lang=js"
export * from "./membershipLotsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports